import { roundToNearestHundred } from './utils'

export const handleRoundToHundred = (e, helpers) => {
  const number = e.target.value
  helpers.setValue(roundToNearestHundred(number || 100))
  helpers.setTouched(true, false)
}

export const handleRestrictLimits = (e, helpers) => {
  const attribs = e.target.attributes
  let number = e.target.value

  if (attribs.max && attribs.max.value) {
    const max = parseFloat(attribs.max.value)
    number = number > max ? max : number
  }

  if (attribs.min && attribs.min.value) {
    const min = parseFloat(attribs.min.value)
    number = number < min ? min : number
  }

  helpers.setValue(number)
  helpers.setTouched(true, false)
}

export const handleRestrictLimitString = (e, helpers) => {
  const attribs = e.target.attributes
  let number = e.target.value

  if (attribs.max && attribs.max.value) {
    const max = parseFloat(attribs.max.value)
    number = String(number > max ? max : number)
  }

  if (attribs.min && attribs.min.value) {
    const min = parseFloat(attribs.min.value)
    number = String(number < min ? min : number)
  }

  helpers.setValue(number)
  helpers.setTouched(true, false)
}
